export class Acl {
    public name: string;
    public value: number;
    public legacy: boolean;
}
